module.exports = __webpack_public_path__ + "static/media/gg.e79e4f59.svg";